import * as React from 'react';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';
import useSiteMetadata from '../hooks/use-site-metadata';

export function Seo(props) {
  const data = useStaticQuery(graphql`
    query GetGlobalImage {
      file(name: { in: "cos-paisatge" }) {
        id
        publicURL
      }
    }
  `);
  const imageToShare = data.file.publicURL;
  const defaults = useSiteMetadata();

  const lang = props.lang || defaults.lang;
  const siteName = props.siteName || defaults.siteName;
  const title = props.title || defaults.title;
  const description = props.description || defaults.description;
  const image = new URL(props.image || imageToShare, defaults.siteUrl);
  const url = new URL(props.path || `/`, defaults.siteUrl);
  const ogType = props.ogType || defaults.ogType;

  return (
    <Helmet>
      <html lang='ca' />
      <title>{title}</title>
      <meta name='description' content={description} />
      <link rel='canonical' href={url} />
      {image && <meta name='image' content={image} />}

      <meta property='og:site_name' content={siteName} />
      <meta property='og:locale' content={lang} />
      <meta property='og:url' content={url} />
      <meta property='og:type' content={ogType} />
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      {image && <meta property='og:image' content={image} />}

      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={title} />
      <meta name='twitter:description' content={description} />
      {image && <meta name='twitter:image' content={image} />}
    </Helmet>
  );
}
